import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { NumberIncrementInputComponent } from "./number-increment-input.component";

@NgModule({
    declarations: [
        NumberIncrementInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    exports: [
        NumberIncrementInputComponent
    ]
})
export class NumberIncrementInputModule{}